export const GOT_PROFILE_INFO_ACTION = {
    name: 'GOT_PROFILE_INFO_ACTION',
    action: (userId, email, firstName, lastName, groups, roles) => ({
        userId, email, firstName, lastName, groups, roles,
        type: GOT_PROFILE_INFO_ACTION.name
    })
};